<ng-container>
	<form #form="ngForm" fxLayout="column" fxLayoutAlign="space-between" novalidate>
		<mat-card style="background-color:#525355;margin:32px 8px 8px 8px;" *ngIf="studio_url">
			<mat-card-header>
				<mat-card-title><span translate>スタジオURL</span></mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<a [href]="studio_url" style="color:#fdfdfd;font-size:18px;font-weight:700;">{{studio_url}}</a>
			</mat-card-content>
		</mat-card>

	</form>
</ng-container>
